import React from "react";
import Skeleton from "components/ui/Skeleton";
import { TYPE_META, fmtCompact } from "../utils";

const TypeBreakdown = ({ data, loading }) => {
  const rows = (data || []).map((d) => {
    const meta = TYPE_META[d.type] || { label: d.type, color: "var(--color-text-muted)" };
    return { ...d, label: meta.label, color: meta.color };
  });
  const maxCampaigns = Math.max(1, ...rows.map((r) => r.campaigns));

  return (
    <div className="rounded-2xl border border-border bg-surface p-5">
      <h2 className="font-semibold text-text_primary mb-4">Email Type</h2>

      {loading ? (
        <Skeleton.Bars rows={2} />
      ) : rows.length === 0 ? (
        <p className="text-sm text-text_muted py-10 text-center">No campaigns in this period</p>
      ) : (
        <div className="space-y-4">
          {rows.map((r) => (
            <div key={r.type}>
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-xs font-medium text-text_secondary">{r.label}</span>
                <span className="text-sm font-semibold text-text_primary">{r.campaigns} campaigns</span>
              </div>
              <div className="w-full bg-surface_alt rounded-full h-1.5 overflow-hidden">
                <div className="h-full rounded-full" style={{ width: `${(r.campaigns / maxCampaigns) * 100}%`, backgroundColor: r.color }} />
              </div>
              <p className="text-[11px] text-text_muted mt-1">{fmtCompact(r.recipients)} total recipients</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TypeBreakdown;
